import { useAtom } from "jotai";
import { GoalAtom, YearsAtom } from "./atoms";
import * as D from "date-fns";
import { opt } from "./utils";
import clsx from "clsx";
import { formatSignedMoney } from "./formatters";
import { Slider } from "@reach/slider";
import * as React from "react";
import * as strings from "./strings";
import { useGetGoalReachedYearDelta } from "./useGetGoalReachedYearDelta";
import { useGetDateFromYearDelta } from "./useGetDateFromYearDelta";
import { useGetProfit } from "./useGetProfit";

const {
  resultheader_goalreached_label,
  resultheader_goalnotreached_label,
  stepresult_overtitle,
  resultheader_missingincome_label,
  resultheader_periodspan_label,
  stepresult_title,
  resultheader_year_text,
  resultheader_years_text
} = strings;

export function ResultHeader() {
  const [years, set_years] = useAtom(YearsAtom);
  const [goal] = useAtom(GoalAtom);
  const getGoalReachedYearDelta = useGetGoalReachedYearDelta();
  const getDateFromYearDelta = useGetDateFromYearDelta();
  const getProfit = useGetProfit();
  const goalReachedYearDelta = getGoalReachedYearDelta();
  let dateFromDayNum = getDateFromYearDelta(goalReachedYearDelta);
  // noinspection RequiredAttributes
  return (
    <div className="atc-result-header">
      <div className="atc-result-header__left-container">
        <p className="at-tagline">{stepresult_overtitle}</p>
        <h2 className="at-title">{stepresult_title}</h2>
      </div>
      <div className="atc-result-header__right-container">
        <div className="atc-result-header__right-container-inner">
          <div className="atc-value-label atc-value-label">
            <span className="atc-value-label__value">
              {opt(dateFromDayNum, d => {
                return D.format(d, "d. MMM yyyy");
              })}
            </span>
            <span className="atc-value-label__text">
              {dateFromDayNum
                ? resultheader_goalreached_label
                : resultheader_goalnotreached_label}
            </span>
          </div>
          <span className="atc-value-label-separator" />
          <div
            className={clsx(
              "atc-value-label",
              getProfit(years) - goal >= 0
                ? "atc-value-label--green"
                : "atc-value-label--red"
            )}
          >
            <span className="atc-value-label__value">
              {formatSignedMoney(getProfit(years) - goal)}
            </span>
            <span className="atc-value-label__text">
              {resultheader_missingincome_label}
            </span>
          </div>
          <span className="atc-value-label-separator" />
        </div>
        <div className="atc-result-header__right-container-inner">
          <div className="atc-result-header__slider">
            <div className="atc-sidebar-slider__slider">
              <div className="at-slider at-slider--small">
                <Slider
                  value={years}
                  onChange={e => {
                    if (Math.abs(years - e) > 0.009) {
                      set_years(e);
                    }
                  }}
                  min={1}
                  max={8}
                  step={1}
                />
                <div className="at-slider__values">
                  <span className="at-slider__value">
                    1 {resultheader_year_text}
                  </span>
                  <span className="at-slider__value">
                    8 {resultheader_years_text}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="atc-value-label">
            <span className="atc-value-label__value">
              {years} {resultheader_years_text}
            </span>
            <span className="atc-value-label__text">
              {resultheader_periodspan_label}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
